
// preserve metric order while adding new metrics to the top
export const preserveOrder = (currentMetrics, appliedMetrics) => {
  const existingMetrics:string[] = [];
  const newEntries:string[] = [];

  // get existing items of the new list in order
  const appliedMetricsSet = new Set(appliedMetrics);
  currentMetrics.forEach( m => {
    if(appliedMetricsSet.has(m)) {
      existingMetrics.push(m);
    }
  });

  // identify new items in default popup order
  const existingMetricsSet = new Set(existingMetrics);
  appliedMetrics.forEach( m => {
    if(!existingMetricsSet.has(m)) {
      newEntries.push(m);
    }
  });

  return [...newEntries, ...existingMetrics];
}

// add new metrics to top, preserve current order
// metricsToAdd - only new metrics
export const addMetricsToList = (currentMetrics, metricsToAdd) => {
  const currentMetricsSet = new Set(currentMetrics);
  const newEntries:string[] = [];

  metricsToAdd.forEach(m => {
    if(!currentMetricsSet.has(m)) {
      newEntries.push(m);
    }
  });

  newEntries.push(...currentMetrics);
  return newEntries;
}
